import React from 'react';
import {
    Tag, Row, Space, Button, Input, DatePicker, Select, Table, Pagination, Checkbox, Tabs, Rate, Col, Popconfirm, Modal
} from 'antd';
import {Redirect, Link, withRouter} from 'react-router-dom';
import store from "../store/store.js";
import {PlusOutlined, UploadOutlined} from '@ant-design/icons'
import {
    PaperClipOutlined,
    LinkOutlined,
    SendOutlined,
    SearchOutlined,
    ReloadOutlined,
    DownloadOutlined
} from '@ant-design/icons'
import moment from 'moment';


const {Option} = Select;
const {RangePicker} = DatePicker;
const {TabPane} = Tabs;

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newcondition: {
                type: 1
            },
            oldcondition: {},
            list: [],
            tableloading: false,
            selectedRowKeys: [],
            count: 0,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {
        // console.log(this.props)
        // let pathname = this.props.location.pathname
        setTimeout(this.getdata(1, null))

    }

    onTimeChange(name, date, dateString) {
        let that = this
        console.log(name, date, dateString)
        let data = Object.assign({}, this.state.newcondition, {[name]: dateString})
        this.setState({
            newcondition: data
        })
    }

    onSelChange(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, {[name]: value})
        this.setState({
            newcondition: data
        })
        setTimeout(() => {
            that.getdata(1, null)
        })
    }

    arrsel(arr) {
        if (arr) {
            return arr.map((item, index) => <Option value={item.id} key={index}>{item.name}</Option>)
        }
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, {[name]: value})
        this.setState({
            newcondition: data
        })
    }

    onRangeChange(name, dates, dateStrings) {
        console.log(name, dates, dateStrings)
        var data = Object.assign({}, this.state.newcondition, {
            [name + '1']: dateStrings[0], [name + '2']: dateStrings[1]
        })
        if (data) {
            this.setState({
                newcondition: data
            })
        }
    }

    pagechange(page, pagesize) {
        let that = this
        console.log(page, pagesize)
        let data = Object.assign({}, this.state.oldcondition, {current: page, pagesize: pagesize})
        setTimeout(() => {
            this.setState({
                oldcondition: data
            })
            that.getdata(0, null)
        })
    }

    onSelectChange = selectedRowKeys => {
        console.log('selectedRowKeys changed: ', selectedRowKeys);
        this.setState({selectedRowKeys});
    };

    onCheckboxChange(name, e) {
        let that = this
        let value = e.target.checked
        console.log(name, value)
        let data = Object.assign({}, this.state.newcondition, {[name]: value})
        this.setState({
            newcondition: data
        })
    }

    getdata = (subtype = 0, e) => {
        // console.log(subtype)
        // return
        let that = this
        that.setState({
            tableloading: true
        })
        if (subtype == 1) {
            var arr = that.state.newcondition
            let old = that.state.oldcondition
            arr = Object.assign({}, arr, {current: 1, pagesize: old.pagesize})
            that.setState({
                oldcondition: arr
            })
        } else {
            var arr = Object.assign({}, this.state.oldcondition, {})
        }
        arr.id = that.props.id
        fetch('/Company/getPayRecord', {
            // post提交
            method: "POST", body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                if (!this.state.newcondition.type) {
                    let newcondition = Object.assign({}, this.state.newcondition, {type: data.type})
                    this.setState({
                        newcondition: newcondition
                    })
                }
                that.setState({
                    list: data.datalist,
                    type_react: data.type_react ? data.type_react : [],
                    tableloading: false,
                    count: Number(data.count)
                })
            })
    }

    onTypeChange(type) {
        let that = this
        let data = Object.assign({}, this.state.newcondition, {type})
        this.setState({
            newcondition: data
        })
        setTimeout(() => {
            that.getdata(1, null)
        })
    }


    render() {
        if (this.state.newcondition.type == 1 || this.state.newcondition.type == 2 || this.state.newcondition.type == 5 || this.state.newcondition.type == 6) {
            var columns = [
                {
                    title: '缴费周期',
                    dataIndex: 'jfzq',
                    key: 'jfzq',
                }, {
                    title: '应收金额',
                    dataIndex: 'num',
                    key: 'num',
                    width: 150,
                }, {
                    title: '已收金额',
                    dataIndex: 'true_num',
                    key: 'true_num',
                    width: 150,
                }, {
                    title: '收款状态',
                    dataIndex: 'status_text',
                    key: 'status_text',
                    width: 100,
                    render: (row, record) => {
                        return (<>
                            {/*{record.status == 1 ? <Tag color={'grey'}>{row}</Tag> : <Tag color={'red'}>{row}</Tag>}*/}
                            {record.status == 1 && <Tag color={'green'}>{row}</Tag>}
                            {record.status == 2 && <Tag color={'blue'}>{row}</Tag>}
                            {record.status == 3 && <Tag color={'red'}>{row}</Tag>}
                            {record.status == 4 && <Tag color={'orange'}>{row}</Tag>}
                            {record.status == 5 && <Tag color={'grey'}>{row}</Tag>}
                        </>)
                    },
                },]
        } else if (this.state.newcondition.type == 7 || this.state.newcondition.type == 8) {
            var columns = [
                {
                    title: '缴费金额',
                    dataIndex: 'true_num',
                    key: 'true_num',
                }, {
                    title: '缴费时间',
                    dataIndex: 'paytime',
                    key: 'paytime',
                    width: 120,
                },
            ]
        } else {
            var columns = [
                {
                    title: '缴费金额',
                    dataIndex: 'true_num',
                    key: 'true_num',
                }, {
                    title: '缴费时间',
                    dataIndex: 'paytime',
                    key: 'paytime',
                    width: 120,
                }, {
                    title: '处理状态',
                    dataIndex: 'status2_text',
                    key: 'status2_text',
                    width: 100,
                    render: (row, record) => {
                        return (<>
                            {record.status2 == 1 && <Tag color={'green'}>{row}</Tag>}
                            {record.status2 == 0 && <Tag color={'red'}>{row}</Tag>}
                        </>)
                    },
                },]
        }
        const {tableloading, selectedRowKeys} = this.state;
        const rowSelection = {
            selectedRowKeys, onChange: this.onSelectChange.bind(this), // hideSelectAll: true,
            preserveSelectedRowKeys: false,
        };
        const hasSelected = selectedRowKeys.length > 0;
        return (<>
            {store.getState().data.info.lmqx_ck ? (store.getState().data.info.lmqx_ck.includes('301') ? <>
                <div className={'view_title'}>
                    <span>缴费信息</span>
                    <Space>
                        <Select
                            style={{
                                width: 180,
                            }}
                            placeholder={'请选择'}
                            value={this.state.newcondition.type ? this.state.newcondition.type : null}
                            onChange={this.onSelChange.bind(this, 'type')} allowClear showSearch
                            optionFilterProp="children"
                            options={this.state.type_react ? this.state.type_react : []}
                        />
                    </Space>
                </div>
                <Table
                    bordered
                    columns={columns}
                    dataSource={this.state.list}
                    pagination={false}
                    style={{width: '100%'}}
                />
                <Row justify={'center'} style={{width: '100%'}}>
                    <Pagination showQuickJumper
                                current={this.state.oldcondition.current ? this.state.oldcondition.current : 1}
                                pageSize={this.state.oldcondition.pagesize ? this.state.oldcondition.pagesize : 10}
                                total={this.state.count} onChange={this.pagechange.bind(this)} showSizeChanger={true}
                                showTotal={total => `共 ${total} 条数据`}/>
                </Row>
            </> : null) : null}
        </>)
    }
}

export default Index
